<!-- Zweck: Stellt die HTML-Struktur für app component im Frontend bereit. -->
<div class="appmain">
  <scanner></scanner>
  <app-page-loader></app-page-loader>
  <update-icon></update-icon>
  <div (click)="bodyClick()" class="mat-typography appbody">
    <router-outlet></router-outlet>
  </div>
  <app-tutorials></app-tutorials>
  <app-footer></app-footer>
</div>
